import { createContext } from 'react';

import type { GetPriceBandResponse } from '@shared/types/frontend/ubff/price-band';
import type { Nullable } from '@shared/types/utils';

export type HotelPriceBandState = {
  response: Nullable<GetPriceBandResponse>;
  isLoading: boolean;
};

const initHotelPriceBandState = {
  response: null,
  isLoading: false,
};

export const AtypicalDealsContext = createContext<HotelPriceBandState>(
  initHotelPriceBandState,
);
